import React from "react";
import { WSPATRReportType } from "../../Component/Model/Enum/BEE123Enums";
import { ChartType } from "../../Component/Model/Enum/ChartType";
import { IChartFactoryProps } from "./ChartFactory";
import { CostAndInterventionChart } from "../../Component/Common/Components/Charts/WSP/CostAndInterventionChart";
import { CostAndHeadcountTrainingChart } from "../../Component/Common/Components/Charts/WSP/CostAndHeadcountTrainingChart";
import { WorkforceProfileOFOCodeSummaryChart } from "../../Component/Common/Components/Charts/WSP/WorkforceProfileOFOCodeSummaryChart/WorkforceProfileOFOCodeSummaryChart";
import { CostAndHeadcountOFOCodeChart } from "../../Component/Common/Components/Charts/WSP/CostAndHeadcountChart";

export const ChartFactoryWSP: React.FC<IChartFactoryProps> = (
    props: IChartFactoryProps
) => {

    if (props.chartType === ChartType.WSPCostAndHeadcountOFOCodeChart)
        return <CostAndHeadcountOFOCodeChart {...props} reportType={WSPATRReportType.WSP} />;

    if (props.chartType === ChartType.ATRCostAndHeadcountOFOCodeChart)
        return <CostAndHeadcountOFOCodeChart {...props} reportType={WSPATRReportType.ATR} />;

    if (props.chartType === ChartType.WSPCostAndHeadcountTrainingChart)
        return <CostAndHeadcountTrainingChart {...props} reportType={WSPATRReportType.WSP} />;

    if (props.chartType === ChartType.ATRCostAndHeadcountTrainingChart)
        return <CostAndHeadcountTrainingChart {...props} reportType={WSPATRReportType.ATR} />;

    if (props.chartType === ChartType.WSPCostAndInterventionChart)
        return <CostAndInterventionChart {...props} reportType={WSPATRReportType.WSP} />;

    if (props.chartType === ChartType.ATRCostAndInterventionChart)
        return <CostAndInterventionChart {...props} reportType={WSPATRReportType.ATR} />;

    if (props.chartType === ChartType.WorkforceProfileOfoMajorGroupSummary)
        return <WorkforceProfileOFOCodeSummaryChart {...props} />

    return null;
};
